import { CheckCircle2, AlertCircle, Info, X, AlertTriangle } from 'lucide-react'

const styles = {
  info: {
    icon: Info,
    classes: 'border-slate-200 bg-white text-slate-800',
    accent: 'text-brand-600',
  },
  success: {
    icon: CheckCircle2,
    classes: 'border-emerald-200 bg-white text-emerald-900',
    accent: 'text-emerald-600',
  },
  error: {
    icon: AlertCircle,
    classes: 'border-rose-200 bg-white text-rose-900',
    accent: 'text-rose-600',
  },
  warning: {
    icon: AlertTriangle,
    classes: 'border-amber-200 bg-white text-amber-900',
    accent: 'text-amber-600',
  },
}

export default function Toast({ toast, onDismiss }) {
  if (!toast) return null
  const variant = styles[toast.kind] || styles.info
  const Icon = variant.icon
  return (
    <div className="pointer-events-none fixed bottom-5 left-1/2 z-50 w-[92vw] max-w-md -translate-x-1/2 animate-fade-in px-2">
      <div
        className={`pointer-events-auto flex items-center gap-3 rounded-xl border px-4 py-2.5 shadow-lift ${variant.classes}`}
      >
        <Icon className={`h-4 w-4 ${variant.accent}`} />
        <p className="text-sm font-medium">{toast.message}</p>
        <button
          onClick={onDismiss}
          className="ml-2 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  )
}
